// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.price-update-modal-wrapper {
  padding: 20px !important;
  width: 90%;
  max-width: 400px;
}
.price-update-modal-wrapper .price-update-modal-body-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 28px;
}
.price-update-modal-wrapper .price-update-modal-body-wrapper h3 {
  margin: 0;
  text-align: center;
}
.price-update-modal-wrapper .price-update-modal-body-wrapper .graph-icon-wrapper {
  width: 60px;
  height: 60px;
}
.price-update-modal-wrapper .price-update-modal-body-wrapper .fares-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  font-weight: 500;
}
.price-update-modal-wrapper .price-update-modal-body-wrapper .fares-wrapper .fare-info-wrapper {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 22px;
}
.price-update-modal-wrapper .price-update-modal-body-wrapper .button-wrapper {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  gap: 20px;
  margin-top: 4px;
}
.price-update-modal-wrapper .price-update-modal-body-wrapper .button-wrapper button {
  white-space: nowrap;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #ddd;
  font-weight: 500;
}
.price-update-modal-wrapper .price-update-modal-body-wrapper .button-wrapper button:last-child {
  background-color: #93288E;
  border: none;
  color: #fff;
}

@media only screen and (width <= 450px) {
  .price-update-modal-wrapper .price-update-modal-body-wrapper .fares-wrapper {
    font-size: 16px;
  }
  .price-update-modal-wrapper .price-update-modal-body-wrapper .button-wrapper {
    justify-content: center;
  }
  .price-update-modal-wrapper .price-update-modal-body-wrapper .button-wrapper button {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/PublicPaymentPage/components/PublicModalWrapper/PriceUpdateModal/style.scss"],"names":[],"mappings":"AAAA;EACI,wBAAA;EACA,UAAA;EACA,gBAAA;AACJ;AACI;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AACR;AACQ;EACI,SAAA;EACA,kBAAA;AACZ;AAEQ;EACI,WAAA;EACA,YAAA;AAAZ;AAGQ;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AADZ;AAGY;EACI,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AADhB;AAKQ;EACI,WAAA;EACA,aAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAHZ;AAKY;EACI,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;AAHhB;AAMY;EACI,yBAAA;EACA,YAAA;EACA,WAAA;AAJhB;;AAUA;EAGY;IACI,eAAA;EATd;EAYU;IACI,uBAAA;EAVd;EAYc;IACI,WAAA;EAVlB;AACF","sourcesContent":[".price-update-modal-wrapper{\n    padding: 20px!important;\n    width: 90%;\n    max-width: 400px;\n\n    .price-update-modal-body-wrapper{\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        gap: 28px;\n\n        h3{\n            margin: 0;\n            text-align: center;\n        }\n\n        .graph-icon-wrapper{\n            width: 60px;\n            height: 60px;\n        }\n\n        .fares-wrapper{\n            width: 100%;\n            display: flex;\n            flex-direction: column;\n            justify-content: center;\n            align-items: center;\n            font-size: 18px;\n            font-weight: 500;\n\n            .fare-info-wrapper{\n                width: 100%;\n                display: flex;\n                justify-content: space-between;\n                align-items: center;\n                gap: 22px;\n            }\n        }\n\n        .button-wrapper{\n            width: 100%;\n            display: flex;\n            flex-wrap: wrap;\n            justify-content: flex-end;\n            align-items: center;\n            gap: 20px;\n            margin-top: 4px;\n\n            button{\n                white-space: nowrap;\n                padding: 8px 16px;\n                border-radius: 4px;\n                border: 1px solid #ddd;\n                font-weight: 500;\n            }\n\n            button:last-child{\n                background-color: #93288E;\n                border: none;\n                color: #fff;\n            }\n        }\n    }\n}\n\n@media only screen and (width <= 450px) {\n    .price-update-modal-wrapper{    \n        .price-update-modal-body-wrapper{    \n            .fares-wrapper{\n                font-size: 16px;\n            }\n    \n            .button-wrapper{\n                justify-content: center;\n    \n                button{\n                    width: 100%;\n                }\n            }\n        }\n    }\n}\n    "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
